import styled, {css, FlattenSimpleInterpolation} from 'styled-components'
import {Strong} from '@modifi/ui'
import {airBlue, semiDarkGray, white} from '@modifi/colors'

import {NavItem, DesktopNavigationWrapper} from '../../styles'

export const ActualItem = styled.div`
  padding: 16px;
  display: flex;
  align-items: center;

  & > span {
    max-width: 300px;
    white-space: initial;
  }

  svg:first-child {
    min-width: 32px;
  }
`

export const LightStrong = styled(Strong)`
  color: ${semiDarkGray};
`

export const NavTitleWrapper = styled.div`
  display: flex;
  align-items: center;

  svg:last-child {
    transition: transform 0.2s;
    transform: rotate(0);
  }
`

export const DummyIcon = styled.div<{height?: number; width?: number}>`
  height: ${(p): number => p.height ?? 0}px;
  width: ${(p): number => p.width ?? 0}px;
  margin-right: 16px;
`

const transparentAirBlue = '#53a2d91a'

// re sc-selector: https://styled-components.com/docs/tooling#interpolation-tagging
export const SecondaryNavList = styled.ul`
  list-style: none;
  transition: height 0.3s;
  padding: 0;
  border-radius: 6px;

  ${/* sc-selector */ DesktopNavigationWrapper} & {
    background-color: ${white};
    overflow-y: hidden;
  }

  li:hover {
    color: ${airBlue};
    background-color: ${transparentAirBlue};

    strong {
      color: ${airBlue};
    }
  }
`

const collapsableNavigationEntryWrapper = css<{childNavHeight?: number}>`
  ${SecondaryNavList} {
    height: 0;
  }

  &:hover {
    ${NavTitleWrapper} {
      svg:last-child {
        transform: rotate(180deg);
      }
    }

    ${SecondaryNavList} {
      height: ${(p): FlattenSimpleInterpolation | string =>
        p.childNavHeight
          ? css`
              ${p.childNavHeight}px
            `
          : 'auto'};
    }
  }
`

export const NavigationEntryWrapper = styled(NavItem)<{
  childNavHeight?: number
  collapsable?: boolean
}>`
  cursor: pointer;
  ${(p): any => (p.collapsable ? collapsableNavigationEntryWrapper : '')}
`
